import React, {useEffect, useRef, useState} from 'react';
import cl from '../../styles/StudEditPage.module.css'
import {useNavigate, useParams} from "react-router-dom";
import Service from "../../API/Service";
import block from '../../Assets/icons/lock_red.svg'
import unblock from '../../Assets/icons/unblock.svg'
import MyInput from "../../components/UI/MyInput/MyInput";
import MyButton from "../../components/UI/MyButtons/MyButton";
import arrow from '../../Assets/icons/Vector.svg'

const StudEditPage = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const dropdownRef = useRef(null); // Для закрытия по клику вне
    const [dropdownOpen, setDropdownOpen] = useState(false); // Состояние меню

    const [departments, setDepartments] = useState([]);
    const [updatedData, setUpdatedData] = useState({
        login: "",
        name: "",
        surname: "",
        birthDate: "",
        phone: "",
        departmentId: null,
        isBlocked: false
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getById(id, "students");
                const data = response?.data || {};

                const departmentsResponse = await Service.getTables("departments");
                setDepartments(departmentsResponse?.data?.content || []);

                const matchedDepartment = departmentsResponse?.data?.content?.find(dep => dep.name === data.departmentName);

                setUpdatedData({
                    login: data.login || "",
                    name: data.name || "",
                    surname: data.surname || "",
                    birthDate: data.birthDate || "",
                    phone: data.phone || "",
                    departmentId: matchedDepartment?.id || null,
                    isBlocked: data.isBlocked || false
                });
            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    const handleChange = (field, value) => {
        setUpdatedData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = async () => {
        try {
            const updatedPayload = {
                name: updatedData.name,
                surname: updatedData.surname,
                phone: updatedData.phone,
                departmentId: updatedData.departmentId
            };
            console.log("updatedPayload:", updatedPayload)

            const response = await Service.updateData(id, updatedPayload, "students");

            if (response.status === 200) {
                alert("Студент успешно обновлен!");
                navigate(-1);
            } else {
                alert("Ошибка при обновлении!");
            }
        } catch (error) {
            console.error("Ошибка:", error);
            alert("Ошибка при обновлении!");
        }
    };

    const blockStudent = async () => {
        try{
            const response = await Service.blockUser("students", id)

            if (response.status === 200) {
                setUpdatedData(prev => ({...prev, isBlocked: true}));
                console.log("Student with ID:" + id + " is blocked");
            } else {
                alert("Ошибка при блокировке!");
            }
        } catch (error){
            console.error("Ошибка:", error);
        }
    }

    const unblockStudent = async () => {
        try{
            const response = await Service.unblockUser("students", id)

            if (response.status === 200) {
                console.log("Student with ID:" + id + " is unblocked");
                setUpdatedData(prev => ({...prev, isBlocked: false}));
            } else {
                console.log("Ошибка при разблокировке!");
            }
        } catch (error){
            console.error("Ошибка:", error);
        }
    }

    const handleDepartmentSelect = (id) => {
        handleChange("departmentId", id);
        setDropdownOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className={cl.mainBlock}>
            <div className={cl.header}>
                <p>Student</p>
                {!updatedData.isBlocked?(
                    <div className={cl.blockBtn} onClick={() => blockStudent()}>
                        Block student
                        <img src={block} alt={'block'}/>
                    </div>
                ):(
                    <div className={cl.unblockBtn} onClick={() => unblockStudent()}>
                        Unblock student
                        <img src={unblock} alt={'unblock'}/>
                    </div>
                )}
            </div>
            <div className={cl.content}>
                <MyInput
                    onChange={(value) => handleChange("name", value)}
                    info={{ name: "Name", value: updatedData.name }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("surname", value)}
                    info={{ name: "Surname", value: updatedData.surname }}
                    isDisabled={false}
                />
                {/* Выпадающий список с департаментами */}
                <div className={cl.dropdown} ref={dropdownRef}>
                    Department
                    <div className={cl.dropdownButton} onClick={() => setDropdownOpen(!dropdownOpen)}>
                        {departments.find(dep => dep.id === updatedData.departmentId)?.name || "Select department"}
                        <img src={arrow} alt={"arrow"} className={dropdownOpen? cl.arrowDown : cl.arrowUp}/>
                    </div>
                    {dropdownOpen && (
                        <ul className={cl.dropdownMenu}>
                            {departments
                                .filter(dep => dep.id !== updatedData.departmentId)
                                .map(dep => (
                                    <li key={dep.id} onClick={() => handleDepartmentSelect(dep.id)} className={cl.dropdownItem}>
                                        {dep.name}
                                    </li>
                                ))}
                        </ul>
                    )}
                </div>
                <MyInput
                    onChange={(value) => handleChange("phone", value)}
                    info={{ name: "Phone number", value: updatedData.phone }}
                    isDisabled={false}
                />
            </div>
            <div className={cl.buttons}>
                <MyButton
                    content={"Back"}
                    isBlue={false}
                    onClick={() => navigate(-1)}
                />
                <MyButton
                    content={"Save changes"}
                    isBlue={true}
                    onClick={handleSave}
                />
            </div>
        </div>
    );
};

export default StudEditPage;